import { Dropdown } from "react-bootstrap";

import {
  MediaGroup,
  Media,
  MediaText,
  Image,
  Icon,
  CustomDropdownToggle,
  CustomDropdownMenu,
  LinkList,
  LinkListItem,
} from "../../components";
import { MdDelete } from "react-icons/md";

import { handleDeleteProduct } from "../../pages/products-manage/ProductsList";
import { createPortal } from "react-dom";
import instance, { imageUrl } from "../../pages/api";
import { ChevronDown } from "lucide-react";
import Swal from "sweetalert2";
import { useState } from "react";
export const productsColumns = ({ setProductsData }) => {
    const handleStatusUpdate = async (product_id, newStatus) => {
        try {
        // Make the PUT request to update the status
        await instance.put(
            `api/Product/update/${product_id}`,
            { status: String(newStatus) }
        );

            // if (response.status === 200) {
            // console.log("Response is ok")
            // If the response is OK, update the state to reflect the new status
            setProductsData((prevData) =>
            prevData.map((product) =>
                product.product_id === product_id
                ? { ...product, status: newStatus }
                : product
            )
            );
                        Swal.fire('Success', 'Product Status updated successfully!', 'success')

     
        } catch (error) {
            console.error("Error updating status:", error);
                        Swal.fire('Error', 'Failed to update Product Status!', 'error')

        }
    };
    
  return [
    {
      name: "Product ID",
      selector: (row) => row.product_id,
      cell: (row) => <span>{row.product_id}</span>,
      sortable: true,
    },

    {
      name: "Product Name",
      selector: (row) => row.name,
      cell: (row) => (
        <MediaGroup>
          <Media
            className="rest-image-last"
            size="md"
            shape="circle"
            variant={row.theme && row.theme}
          >
            {row.image ? (
              <Image src={`${imageUrl}${row.image}`} staticImage />
            ) : (
              ""
            )}
          </Media>
          <MediaText>
            <span className="small text" style={{ whiteSpace: "nowrap" }}>
              {row.name}
            </span>
          </MediaText>
        </MediaGroup>
      ),
      sortable: true,
      minWidth: "250px",
    },
    {
      name: "Created Date",
      selector: (row) => row.createdAt,
      cell: (row) => <span>{new Date(row.createdAt).toDateString()}</span>,
      sortable: true,
      minWidth: "150px",
    },
    {
      name: "Price",
      selector: (row) => row.price,
      cell: (row) => <span>{row.price}</span>,
      sortable: true,
    },
    {
      name: "Shelf Life",
      selector: (row) => row.shelf_life,
      cell: (row) => <span>{row.shelf_life}</span>,
      sortable: true,
    },
    //     name: "Outside Price",
    //     selector: (row) => row.price,
    //     cell: (row) => (
    //         <span>{row.price}</span>
    //     ),
    //     sortable: true,
    // },
    // {
    //     name: "India Price",
    //     selector: (row) => row.ind_price,
    //     cell: (row) => (
    //         <span>{row.ind_price}</span>
    //     ),
    //     sortable: true,
    // },

    // {
    //     name: "Sorting Order",
    //     selector: (row) => row.sort_order,
    //     cell: (row) => (
    //         <span>{row.sort_order}</span>
    //     ),
    //     sortable: true,
    // },

    // {
    //     name: "Quantity",
    //     selector: (row) => row.quantity,
    //     cell: (row) => (
    //         <span>{row.quantity}</span>
    //     ),
    //     sortable: true,
    // },
    // {
    //     name: "Model",
    //     selector: (row) => row.model,
    //     cell: (row) => (
    //         <span>{row.model}</span>
    //     ),
    //     sortable: true,
    // },
    {
      name: "Status",
      selector: (row) => row.status,
      cell: (row) => (
                <StatusCell row={row} onStatusChange={handleStatusUpdate} />

        // <div
        //   className={`d-flex justify-content-center align-items-center rounded`}
        //   style={{
        //     color: row.status === 1 ? "#198754" : "#dc3545", // Bootstrap success and danger text colors
        //     backgroundColor: row.status === 1 ? "#d1e7dd" : "#f8d7da", // Bootstrap success and danger light backgrounds
        //     width: "93px",
        //     height: "28px",
        //     cursor: "pointer",
        //   }}
        //   onClick={() => console.log(row.status)}
        // >
        //   {row.status == 1 ? "Active" : "Inactive"}
        // </div>
      ),
      sortable: true,
      },
    
      

    {
      name: "action",
      cell: (row) => (
        <div className="text-end w-100">
          <Dropdown>
            <Dropdown.Toggle
              size="sm"
              as={CustomDropdownToggle}
              className="btn btn-sm btn-icon btn-zoom me-n1"
            >
              <Icon name="more-v"></Icon>
            </Dropdown.Toggle>
            {createPortal(
              <Dropdown.Menu
                className="dropdown-menu-sm"
                as={CustomDropdownMenu}
                align="end"
              >
                <div className="dropdown-content py-1">
                  <LinkList className="link-list-hover-bg-primary link-list-md">
                    <LinkListItem
                      to={`/products-manage/products-list/${row.product_id}`}
                    >
                      <Icon name="edit"></Icon>
                      <span>Edit</span>
                    </LinkListItem>

                    <LinkListItem
                      className="delete-ittem"
                      to="#"
                      onClick={() =>
                        handleDeleteProduct(row.product_id, setProductsData)
                      }
                    >
                      <MdDelete />
                      <span>Delete</span>
                    </LinkListItem>
                  </LinkList>
                </div>
              </Dropdown.Menu>,
              document.body
            )}
          </Dropdown>
        </div>
      ),
      sortable: false,
    },
  ];
};



const StatusCell = ({ row, onStatusChange }) => {
  // const [dropdownVisible, setDropdownVisible] = useState(false);

  // const handleDropdownToggle = () => {
  //   setDropdownVisible(!dropdownVisible);
  // };

 const handleStatusChange = (newStatus) => {
    // Call the onStatusChange function passed from the parent
    onStatusChange(row.product_id, newStatus);
    // Hide the dropdown after selection
    // setDropdownVisible(false);
  };


  return (
     <div className="text-center ">
      <Dropdown>
        <Dropdown.Toggle
          size="sm"
          as={CustomDropdownToggle}
          className="btn-zoom"
        >
          <div
            className={`d-flex justify-content-center align-items-center rounded`}
            style={{
              color: row.status === 1 ? "#198754" : "#dc3545",
              backgroundColor: row.status === 1 ? "#d1e7dd" : "#f8d7da",
              width: "93px",
              height: "28px",
              cursor: "pointer",
            }}
          >
            {row.status === 1 ? "Active" : "Inactive"}{" "}
            {row.status === 1 ? (
              <ChevronDown color="#198754" size={18} />
            ) : (
              <ChevronDown color="#dc3545" size={18} />
            )}
          </div>
        </Dropdown.Toggle>
        {createPortal(
          <Dropdown.Menu
            className="dropdown-menu-sm"
            as={CustomDropdownMenu}
            align="end"
          >
            <div className="dropdown-content py-1">
              <LinkList className="link-list-hover-bg-primary link-list-md">
                <button
                  className="dropdown-item"
                  onClick={() => handleStatusChange(1)}
                >
                  Active
                </button>
                <button
                  className="dropdown-item"
                  onClick={() => handleStatusChange(0)}
                >
                  Inactive
                </button>
              </LinkList>
            </div>
          </Dropdown.Menu>,
          document.body
        )}
      </Dropdown>
    </div>


    // <div className="position-relative">
    //   <div
    //     className={`d-flex justify-content-center align-items-center rounded`}
    //     style={{
    //       color: row.status === 1 ? "#198754" : "#dc3545",
    //       backgroundColor: row.status === 1 ? "#d1e7dd" : "#f8d7da",
    //       width: "93px",
    //       height: "28px",
    //       cursor: "pointer",
    //     }}
    //     onClick={handleDropdownToggle}
    //   >
    //     {row.status === 1 ? "Active" : "Inactive"} {row.status === 1 ? <ChevronDown color="#198754"  size={18} /> : <ChevronDown color="#dc3545" size={18} />} 
    //   </div>
      
    //   {dropdownVisible && (
    //     <div className="dropdown-menu show" style={{ position: 'absolute', top: '100%', left: '0'}}>
    //       <button className="dropdown-item" onClick={() => handleStatusChange(1)}>Active</button>
    //       <button className="dropdown-item" onClick={() => handleStatusChange(0)}>Inactive</button>
    //     </div>
    //   )}
    // </div>
  );
};